export default __webpack_public_path__ + "static/media/buku-besar2.163df64f.png";